import { createRoute, Navigate } from '@tanstack/react-router';
import { protectedLayoutRoute } from './protectedLayout';

export const indexRoute = createRoute({
  getParentRoute: () => protectedLayoutRoute,
  path: '/',
  component: () => <Navigate to="/dashboard" />,
});
